import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
/**
 * Defer the update of a value by a specified delay.
 *
 * @example
 *
 * ```js
 * const [show, setShow] = useState(false)
 * const delayedShow = useDelay(show, 500)
 * ```
 *
 * if `show` changes from false to true, after 500ms delayedShow
 * will change to true. This allows you to declaratively respond
 * to state changes after a specified duration.
 *
 */

export function useDelayedState(state, _ref) {
  var delay = _ref.delay,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? null : _ref$initialState,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      delayed = _useState2[0],
      setDelayed = _useState2[1];

  useEffect(function () {
    var timer = setTimeout(function () {
      if (enabled) {
        setDelayed(state);
      }
    }, delay);
    return function () {
      return clearInterval(timer);
    };
  }, [state, delay, enabled]);
  return enabled ? delayed : state;
}